import script from "./TagsView.vue?vue&type=script&setup=true&lang=js"
export * from "./TagsView.vue?vue&type=script&setup=true&lang=js"

import "./TagsView.vue?vue&type=style&index=0&id=ccf3167a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ccf3167a"]])

export default __exports__